import { PieChart } from '@mui/x-charts/PieChart'
import { Box } from '@mui/material'
import GLOBAL from "modules/global"
import { chartSx } from './chartDefaults'
import PieCenterLabel from "./PieCenterLabel"
import PieLegendList from "./PieLegendList"

const CATEGORY_COLORS = ['#1565C0', '#FF9800', '#4CAF50', '#9C27B0', '#607D8B']

interface Props {
  data: { category: string; count: number; percentage: number }[]
}

const ServiceCategoryMixChart = ({ data }: Props) => {
  if (!data || data.length === 0) return null

  const totalBooking = data.reduce((acc, item) => acc + item.count, 0)

  return (
    <Box display="flex" flexWrap="wrap" gap={2}>
      <Box flex="1 1 320px">
        <PieChart
          margin={{ left: 100 }}
          series={[
            {
              innerRadius: 70,
              outerRadius: 100,
              data: data.map((item, idx) => ({
                id: idx,
                value: item.count,
                label: `${item.category} (${item.percentage.toFixed(1)}%)`
              }))
            }
          ]}
          colors={CATEGORY_COLORS}
          height={300}
          sx={{ flexShrink: 0, ...chartSx }}
          slotProps={{
            legend: {
              hidden: true
              // position: { horizontal: 'right', vertical: 'middle' },
              // padding: 0
            }
          }}
        >
          <PieCenterLabel primary="Total Booking" secondary={totalBooking.toLocaleString('id-ID')} />
        </PieChart>
      </Box>
      <Box display={'flex'} flex="2 1 480px" alignItems={'center'}>
        <PieLegendList
          items={(data ?? []).map((item) => ({
            color: GLOBAL.generateColorFromLabel(item.category),
            label: item.category,
            value: ` ${item.count.toLocaleString('id-ID')} (${item.percentage.toFixed(1)})%`
          }))}
        />
      </Box>
    </Box>
  )
}

export default ServiceCategoryMixChart